<template>
  <div class="player-container">
    <div class="base-info">
      <el-card class="box-card">
        <el-form :inline="true">
          <el-row>
            <el-form-item label="起止日期">
              <el-date-picker
                v-model="search.begin"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
              <span>-</span>
              <el-date-picker
                v-model="search.end"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="岗位">
              <el-select v-model="search.type" @change="quickSearch" placeholder="请选择" clearable>
                <el-option
                  v-for="(item, i) in types"
                  :key="i"
                  :label="item"
                  :value="i"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="quickSearch">查询</el-button>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="matchName">
        <template slot="header" slot-scope="scope">
          <div>赛事</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeStatsRouter(scope.row)">{{scope.row.matchName}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatMatchType"
        prop="matchType"
        label="比赛类型"
        width="80">
      </el-table-column>
      <el-table-column
        prop="groupName"
        width="110">
        <template slot="header" slot-scope="scope">
          <div>组别</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="stageName"
        width="150">
        <template slot="header" slot-scope="scope">
          <div>阶段</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="homeTeamName">
        <template slot="header" slot-scope="scope">
          <div>主队</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="awayTeamName">
        <template slot="header" slot-scope="scope">
          <div>客队</div>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatType"
        prop="type"
        label="岗位"
        width="130">
      </el-table-column>
      <el-table-column
        prop="seq"
        width="60">
        <template slot="header" slot-scope="scope">
          <div>场次</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getGameRouter(scope.row)">{{scope.row.seq}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="130"
        prop="beginDate">
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

  import * as moment from 'moment'
  import permission from '@/directive/permission/index.js' // 权限判断指令
  import checkPermission from '@/utils/permission' // 权限判断函数
  import { AdminGetRefereeGameList, ExportRefereeYearsData } from '@/api/referee'
  import { ImageFormat} from "@/utils";
  import { getMemberShipYearList } from '@/api/site'

  const defaultForm = {}

  export default {
    name: 'RefereeGameList',
    directives: { permission },
    data() {
      return {
        search: {
          type: null
        },
        list: [],
        totalCount: 0, // 默认数据总数
        pageSize: 10, // 每页的数据条数
        currentPage: 1, // 默认开始页面
        listQuery: {},
        listLoading: true,
        routerParams: {},
        types:["主裁","边裁","裁判监督","计时","记录","宣告","记罚","助理","比赛监督"],
        matchTypes:["标准比赛","小场地","国际","国家","市级","地区"],
        typeCount:{},
        referee:{
          smallProfile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
          profile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
          smallImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
          bigImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
          smallBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
          bigBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
        },
        years:[],
        yearIndex: null,
        trainings:[],
        matchType0:0,
        matchType1:0
      }
    },
    created() {
      this.routerParams = {
        id: this.$route.params.refereeId,
        userId: this.$route.params.uId
      }
      if(this.$route.query.matchId) {
        this.search.matchId = this.$route.query.matchId
      }
      if(this.$route.query.type) {
        this.search.type = parseInt(this.$route.query.type, 10)
      }
      this.getMembershipYear()
      this.getList()
    },
    methods: {
      checkPermission,
      exportYearsData(){
        ExportRefereeYearsData({refereeId: this.routerParams.id}).then(resolve=>{
          const url = resolve && resolve.data.url;
          window.open(process.env.BJH_API + decodeURIComponent(url), '_blank')
          this.$message({
            message: '导出数据成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        })
      },
      formatCertType(type) {
        const t = parseInt(type)
        return t === 1 ? "身份证" : (t === 2 ? "护照" : (t === 3 ? "出生证" : (t === 4 ? "驾照" : "-")))
      },
      getRefereeInfoRouter(){
        return this.referee && this.referee.inField === 1 ? {path: `/in-referee/edit/${this.routerParams.id}`} : {path: `/out-referee/edit/${this.routerParams.id}`}
      },
      setYearTime(){
        if(this.yearIndex === 0 || this.yearIndex) {
          const item = this.years[this.yearIndex]
          this.search.begin = item.membershipBeginDate//moment(item.membershipBeginDate).format('YYYY-MM-DD')
          this.search.end = item.membershipEndDate//moment(item.membershipEndDate).format('YYYY-MM-DD')
        } else {
          this.search.begin = null;
          this.search.end = null;
        }
      },
      ImageFormats(img, size) {
        img = img || 'Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
        return ImageFormat.squareImageView(img, size)
      },
      certImageFormats(img, w, h) {
        img = img || 'Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
        return ImageFormat.imageView(img, w, h)
      },
      getGameRouter(row){
        if(row.groupId) return {path: `/league/${row.matchId}/group/${row.groupId}/game/${row.gameId}/scores`}
        else
          return {path: `/league-old/${row.matchId}/referee-update/${row.gameId}`}
      },
      // routerMatchTypeList(){
      //   this.$router.push({path: `/league/league-referee-match-type-list/${this.routerParams.id}/${this.routerParams.userId}`});
      // },
      getMatchRefereeStatsRouter(row) {
        if(row.groupId) return {path: `/league/${row.matchId}/referees`}
        else
          return {path: `/league-old/${row.matchId}/referees`}
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.$router.push({path: this.$route.path, query: {page: val}})
        this.currentPage = val
        this.getList()
      },
      quickSearch() {
        this.getList()
      },
      getMembershipYear(){
        getMemberShipYearList().then(resolve=>{
          const data = resolve.data
          this.years = data.list
        })
      },
      getList() {
        this.listLoading = true
        this.listQuery = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          refereeId: this.routerParams.id
        }
        if (this.search.createDate) {
          this.search.createDate = moment(this.search.createDate).format('YYYY-MM-DD')
        }
        this.listQuery = Object.assign(this.listQuery, this.search)
        AdminGetRefereeGameList(this.listQuery).then(response => {
          const data = response.data;
          const referee = data.referee
          referee.smallProfile = this.ImageFormats(referee.profile, 150)
          referee.profile = this.ImageFormats(referee.profile, 1000)
          referee.smallImage = this.certImageFormats(referee.certificateFrontImg, 150, 94)
          referee.bigImage = this.certImageFormats(referee.certificateFrontImg, 1000, 1000)
          referee.smallBackImage = this.certImageFormats(referee.certificateBackImg, 150, 94)
          referee.bigBackImage = this.certImageFormats(referee.certificateBackImg, 1000, 1000)
          this.referee = data.referee
          this.trainings = data.trainings
          this.list = data.list
          this.currentPage = data.pageNum
          this.totalCount = data.count
          this.listLoading = false
          this.typeCount = data.types
          this.matchTypeList = data.matchTypes
          this.matchType0 = this.getMatchTypeCount(this.matchTypeList, 0)
          this.matchType1 = this.getMatchTypeCount(this.matchTypeList, 1)
        })
      },
      getMatchTypeCount(list, type) {
        for(let i in list) {
          const item = list[i]
          if(item.type == type) {
            return item.type0*1 +item.type1*1 +item.type2*1 +item.type3*1 +item.type4*1 +item.type5*1 +item.type6*1 +item.type7*1 +item.type8*1
          }
        }
        return 0
      },
      formatDate: function(row, column) {
        const date = row[column.property]
        return date && moment(date).format('YYYY-MM-DD HH:mm')
      },
      formatDate2: function(date) {
        return date && moment(date).format('YYYY-MM-DD')
      },
      formatType: function (row, column) {
        const t = row.type;
        if(t >= 0 && t <= 8)
          return this.types[t]
        else
          return "-"
      },
      formatMatchType: function (row, column) {
        const t = row.matchType;
        if(t >= 0 && t <= 5)
          return this.matchTypes[t]
        else
          return "-"
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .player-container {
    margin: 30px 15px;
    .base-info {
      margin-bottom: 20px;
      .box-card {
        width: 800px;
        .item {
          padding: 10px 0;
        }
        .export-btn {
          margin-left: 30px;
        }
      }
    }
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
  .type-count {
    text-align: center;
  }
  .profile{
    display: inline-block;
    width: 106px;
    height: 144px;
  }
  .cert{
    display: inline-block;
    height: 94px;
    width: 150px;
  }
  .info{
    padding: 0 0 4px 0;
  }
</style>
